export var Trigger;
(function (Trigger) {
    Trigger["Click"] = "click";
    Trigger["Focus"] = "focus";
    Trigger["Hover"] = "hover";
    Trigger["Manual"] = "manual";
})(Trigger || (Trigger = {}));
